export default function HeroSection() {
  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section id="hero" className="relative min-h-screen w-full overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/0c810d1ec2e40adcffcfc526014788ce.jpg"
          alt="Hero Background"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-black/70" />
      </div>

      {/* Content */}
      <div className="relative z-10 flex flex-col items-center justify-center min-h-screen text-center px-6 pt-24 pb-16">
        {/* Peter's Photo */}
        <div className="mb-6">
          <img
            src="https://static.readdy.ai/image/b0d28b98390413eddff47342c2e73859/e7ecfe6710dde15818a557b4ab6fc3d8.jpeg"
            alt="Peter Michael Gits"
            className="w-32 h-32 rounded-full object-cover object-top border-4 border-teal-400 shadow-2xl mx-auto"
          />
        </div>

        <h1 className="font-['Playfair_Display'] font-bold text-white mb-4 leading-tight text-center">
          <div className="text-5xl lg:text-7xl mb-2">GITS</div>
          <div className="text-4xl lg:text-6xl flex flex-col items-center">
            <span>Global</span>
            <span>Innovation</span>
            <span>Technology</span>
            <span>Solutions</span>
          </div>
        </h1>
        <p className="text-teal-300 text-xl lg:text-2xl font-medium mb-3 tracking-wide">
          AI Innovation Leadership
        </p>
        <p className="text-white/70 text-base lg:text-lg mb-10 max-w-2xl leading-relaxed">
          Helping businesses harness the power of{' '}
          <em
            className="font-semibold text-3xl lg:text-4xl italic"
            style={{
              background: 'linear-gradient(135deg, #f97316, #fb923c, #fbbf24)',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
              backgroundClip: 'text',
              filter: 'drop-shadow(0 0 12px rgba(251, 146, 60, 0.7))',
              paddingRight: '0.15em',
              paddingBottom: '0.1em',
              display: 'inline-block',
            }}
          >Conversational AI</em>{' '}
          to drive growth, efficiency, and competitive advantage. Headquartered in Charlotte, NC.
        </p>

        {/* CTA Buttons */}
        <div className="flex flex-wrap items-center justify-center gap-3">
          <a
            href="https://jessica.readdy.co"
            target="_blank"
            rel="noopener noreferrer"
            className="px-6 py-3 bg-teal-500 hover:bg-teal-400 text-white font-semibold rounded-full transition-all duration-200 shadow-lg hover:shadow-teal-500/40 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-robot-line mr-2"></i>Break Jessica
          </a>
          <button
            onClick={() => scrollTo('contact')}
            className="px-6 py-3 bg-white/10 hover:bg-white/20 text-white font-semibold rounded-full border border-white/30 backdrop-blur-sm transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-mail-line mr-2"></i>Get In Touch
          </button>
          <a
            href="https://betty.readdy.co"
            target="_blank"
            rel="noopener noreferrer"
            className="px-6 py-3 bg-amber-500 hover:bg-amber-400 text-white font-semibold rounded-full border border-amber-400 transition-all duration-200 shadow-lg hover:shadow-amber-500/40 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-mic-line mr-2"></i>Read Grocery List to Betty
          </a>
          <a
            href="https://stephanie.petergits.com"
            target="_blank"
            rel="noopener noreferrer"
            className="px-6 py-3 bg-rose-500 hover:bg-rose-400 text-white font-semibold rounded-full border border-rose-400 transition-all duration-200 shadow-lg hover:shadow-rose-500/40 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-user-smile-line mr-2"></i>Pizza Chef Stephanie
          </a>
        </div>

        {/* Scroll Indicator */}
        <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 animate-bounce">
          <span className="text-white/50 text-xs tracking-widest uppercase">Scroll</span>
          <i className="ri-arrow-down-line text-white/50 text-lg"></i>
        </div>
      </div>
    </section>
  );
}
